module.exports = __webpack_public_path__ + "img/52.37c8120e.jpg";